import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=0d05fdd4&scoped=true&"
import script from "./MenuLink.vue?vue&type=script&lang=js&"
export * from "./MenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d05fdd4",
  null
  
)

export default component.exports